import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bandcamp-brands",
  "use": "bandcamp-brands-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"bandcamp-brands\"><path d=\"M12 .375C5.578.375.375 5.578.375 12S5.578 23.625 12 23.625 23.625 18.422 23.625 12 18.422.375 12 .375zm2.26 15.286H5.774l3.97-7.317h8.485l-3.97 7.317z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol